import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function OrderConfirmed() {
  const [orderId, setOrderId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedOrderId = sessionStorage.getItem("orderId");

    if (!storedOrderId) {
      navigate("/"); // 🚫 direct access block
      return;
    }

    setOrderId(storedOrderId);
    // 🔥 remove after first load
    sessionStorage.removeItem("orderId");
  }, []);

  if (!orderId) return null;

  return (
    <>
      <div className="flat-spacing pb-0 mb-5">
        <div className="container">
          <div className="title-success-order text-center">
            <img
              className="icon"
              src={`${process.env.PUBLIC_URL}/images/section/success.svg`}
              alt="Success"
            />
            <div className="box-title">
              <h3 className="title">🎉 Order Confirmed</h3>
              <p className="text-md text-dark">
                Thank you for your order! <strong>Order ID:</strong> {orderId}.
                <br />
                Thank you so much for your purchase.
              </p>
            </div>

            <div className="row mt-5">
  <div className="col-md-12">
    <div className="d-flex flex-column flex-sm-row justify-content-center align-items-stretch gap-3">
      <Link to="/" className="tf-btn animate-btn justify-content-center">
        Go to HomePage
      </Link>
      <Link
        to="/users/orders"
        className="tf-btn animate-btn justify-content-center"
      >
        Go to Order List
      </Link>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderConfirmed;
